<template>
  <div class="layout-page">
    <el-menu
      :default-active="active"
      class="el-menu-vertical-demo"
      :router="true"
      :collapse-transition="false"
    >
      <div class="back-container" @click="backClick">
        <div class="back-icon"></div>
        <div class="back-text">Schedule</div>
      </div>
      <el-menu-item index="instagrams">
        <span slot="title">Added Social Account</span>
      </el-menu-item>
      <el-menu-item index="premium-instagrams">
        <span slot="title">Unlimited Schedules</span>
      </el-menu-item>
      <el-menu-item index="members">
        <span slot="title">Team Member</span>
      </el-menu-item>
      <el-menu-item index="plans">
        <span slot="title">Upgrade Plan</span>
      </el-menu-item>
      <el-menu-item index="billing">
        <span slot="title">Payment</span>
      </el-menu-item>
    </el-menu>
    <div class="right-container">
      <router-view />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme";

.layout-page {
  height: 100vh;
  display: flex;
  .right-container {
    flex: 1;
    min-width: 300px;
  }
  .back-container {
    height: 80px;
    text-align: left;
    border-right: 3px solid transparent;
    padding-left: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 40px;
    line-height: 1;
    &:hover,
    &:active {
      opacity: 0.7;
    }
    .back-icon {
      height: 25px;
      width: 25px;
      background: url("../../../public/images/common/Calender_icon_Back@3x.png");
      background-size: contain;
    }
    .back-text {
      position: relative;
      top: 2px;
    }
  }
}
</style>
<style>
.el-menu-vertical-demo {
  min-height: 100vh;
}
</style>

<script>
import { mapGetters } from "vuex";
import { ACCOUNT_BACK } from "../../store/mutation-types";

export default {
  name: "LayoutPage",
  computed: {
    ...mapGetters({
      accountBack: ACCOUNT_BACK,
    }),
    active() {
      return this.$route.path.split("/account/")[1];
    },
  },
  data() {
    return {
      backPath: {},
    };
  },
  methods: {
    /**
     * 返回按钮点击
     */
    backClick() {
      this.$router.push({ name: "SchedulePage" });
    },
  },
};
</script>
